import classNames from 'classnames';
import React from 'react';
import FocalPoint from './focal-point';

interface Props {
  active?: boolean;
  className?: string;
  baseClassName?: string;
  onExit?: (event: React.KeyboardEvent) => void;
  children: React.ReactNode;
  element?: string;
}

const FocusTrap = (props: Props): React.ReactElement => {
  const {
    active = true,
    onExit,
    className,
    baseClassName = 'focus-trap',
    children,
    element,
  } = props;

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Escape') {
      onExit?.(event);
    }
  };

  if (!active) return <>{children}</>;

  return (
    <div className={classNames(`${baseClassName}-wrapper`, className)} onKeyDown={handleKeyDown}>
      <FocalPoint className={baseClassName} element={element}>
        {children}
      </FocalPoint>
    </div>
  );
};

export default FocusTrap;
